// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Virhekoodi:",
    "error.search": "Saat lisätietoja tekemällä hakuja tietokannastamme",
    dismiss: "hylkää",
    "installation.title": "",
    "cancelation.button": "Peruuta",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Alustus epäonnistui",
      description: "Emme voineet hahmontaa sivua. Ota yhteyttä tukeen.",
    },
    "EOS-UI-UE": {
      title: "Jokin meni vikaan",
      description: "Jokin meni vikaan. Ota yhteyttä tukeen.",
    },
    "EOS-IN-BC": {
      title: "Asennus epäonnistui",
      description:
        "Emme voineet näyttää asennuksen edistymistä. Ota yhteyttä tukeen.",
    },
    "EOS-IN-UE": {
      title: "Asennus epäonnistui",
      description: "Jokin meni vikaan. Ota yhteyttä tukeen.",
    },
    "EOS-IN-FF": {
      title: "Asennus epäonnistui",
      description:
        "Emme voineet muodostaa yhteyttä Epic Online Services -palveluihin. Ota yhteyttä tukeen.",
    },
    "EOS-IN-FF-*": {
      title: "Asennus epäonnistui",
      description:
        "Emme voineet suorittaa Epic Online Services -palveluille esitettyä pyyntöä. Ota yhteyttä tukeen.",
    },
    fallback: {
      title: "Jokin meni vikaan",
      description: "Jokin meni vikaan. Ota yhteyttä tukeen.",
    },
  },
};
